// extracted by mini-css-extract-plugin
export default {"v-application":"ConfirmDialog_v-application_JOjA_","text-h1":"ConfirmDialog_text-h1_yiRDB","text-h2":"ConfirmDialog_text-h2_PJtUs","text":"ConfirmDialog_text_r6eva"};